<template>
  <v-alert
    v-model="showPrivacy"
    prominent
    icon="mdi-cookie"
    dark
    class="pl-5 alert-style"
  >
    <v-row align="center">
      <v-col class="grow">
        <h3 class="text-h7"><b>
            {{ $t('privacyPolicy') }}
          </b></h3>
        {{ $t('cookieDescription') }}
        <v-divider class="my-2"></v-divider>
        {{ $t('cookieMoreDetail') }}
        <v-btn
          x-small
          light
          depressed
          @click="moreDetail"
          color="rgb(255, 255, 255, 0.9)"
        >{{ $t('moreDetail') }}
          <v-icon right>
            mdi-arrow-right-thick
          </v-icon>
        </v-btn>
      </v-col>
      <v-col class="shrink">
        <v-btn
          depressed
          light
          class="mr-2"
          @click="agree"
        >{{ $t('agree') }}</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  data: () => ({
    showPrivacy: false,
  }),
  created() {
    if (Cookies.get('privacy-policy-synmachine') === undefined) {
      this.showPrivacy = true;
    }
  },
  methods: {
    agree() {
      Cookies.set('privacy-policy-synmachine', 'agree', { expires: 10000 });
      this.showPrivacy = false;
    },
    moreDetail() {
      const lang = this.$i18n.locale;
      this.$router.push({ path: `/${lang}/privacyPolicy` }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
  .alert-style {
    background-color: rgb(0, 0, 0, 0.8);
  }
  @media screen and (min-width: 1264px) {
    .alert-style {
      background-color: rgb(255, 255, 255, 0.2);
    }
  }
</style>
